import { FaFolder } from "react-icons/fa";
import { Row, Col, } from "react-bootstrap";
import { FaFilePdf, FaEye } from "react-icons/fa"
import { useNavigate } from "react-router-dom";
import LoadingBar from "../toaster/loader/loader";
import { useState } from "react";
import { getHospitalSharedDoc, getSchoolSharedDoc } from "../../../services/utils";
export const FileStructure = (props) => {
    const navigate = useNavigate()
    const role = localStorage.getItem("PageTittle")
    const [loadin, Setloading] = useState(false)
    return (
        <div className="files_cards">

            <Row>
                {loadin &&
                    <LoadingBar />
                }
                {
                    props.shardFiles && props.shardFiles.length > 0 ?
                        props.shardFiles.filter((res) => (res?.custom_file_and_folder?.type) && res?.custom_file_and_folder?.type == "folder")
                            .map(curr => {
                                return (
                                    <Col sm="6" onClick={() => { navigate(`/school-files/${curr.custom_file_id}`) }}>
                                        <div className="file_card crd_orng mb-3">
                                            <div className="fldr_icn txt_orng">
                                                <FaFolder />
                                            </div>
                                            <h5>
                                                {curr.custom_file_and_folder?.name}
                                            </h5>
                                            {/* <p>900 files</p> */}
                                        </div>
                                    </Col>
                                )
                            })
                        :
                        <Col sm="12">
                            <div className="file_card mb-3" style={{ textAlign: "center" }}>
                                No Shared Folder or Files
                            </div>
                        </Col>
                }
                {

                    props.shardFiles && props.shardFiles.length > 0 &&
                    props.shardFiles.filter((res) => res?.custom_file_and_folder?.type == "file")
                        .map(curr => {
                            return (
                                <Col sm="12">
                                    <div className="file_card mb-3 crd_orng d-flex justify-content-between align-items-center" >
                                        <div className="d-flex">
                                            <div className="fl_icn txt_orng">
                                                <FaFilePdf />
                                            </div>
                                            <h6 style={{ marginLeft: "15px" }}>
                                                {curr.custom_file_and_folder?.name}
                                            </h6>
                                        </div>
                                        <h6>
                                            {curr.custom_file_and_folder?.size}kb
                                        </h6>

                                        <div className="txt_orng" onClick={() => {
                                            Setloading(true)
                                            if (role === 'Hospital') {
                                                getHospitalSharedDoc({
                                                    document: curr.custom_file_and_folder?.name,
                                                    type: "cstm_file"
                                                }).then(resp => {
                                                    Setloading(false)
                                                }).catch(err => {
                                                    Setloading(false)
                                                })
                                            } else {
                                                getSchoolSharedDoc({
                                                    document: curr.custom_file_and_folder?.name,
                                                    type: "cstm_file"
                                                }).then(resp => {
                                                    Setloading(false)
                                                }).catch(err => {
                                                    Setloading(false)
                                                })
                                            }
                                        }} style={{ marginRight: "20px" }}>
                                            <FaEye />
                                        </div>
                                    </div>
                                </Col>
                            )
                        })
                }

            </Row >
        </div>
    )
}